import React from "react";
import styled from "styled-components";

import { rhythm } from "../utils/typography";
import { HoverUnderline } from './styleComponents/HoverStyles'
import SocialIcons from "./SocialIcons";

const PathImage = styled.div`
  margin-bottom:-${rhythm(0.5)};
  & > svg {
    >path{
      fill:var(--color-foreground);
    }
  }
`;

const FooterContentDiv = styled.div`
  background:var(--color-foreground);
  text-align:center;
  max-width: ${rhythm(36)};
  padding-bottom: ${rhythm(1)};
  margin:0 auto;
`;

const IconDiv = styled.div`
  margin:0;
  display: flex; 
  justify-content:center;
  gap: .5ch;
  a{
    margin:${rhythm(0.4)};
    color:var(--color-gray1);
  }
  > a:hover{
    color:var(--color-secondary);
  }
`;

const Quote = styled.h1`
    display:inline-block;
    font-family:"Reenie Beanie";
    font-size:2.8rem;
    font-weight:normal;
    background-image: linear-gradient(120deg, #f5576c 0%,  #a6c1ee 100%);
    background-clip: text;
    text-fill-color: transparent;
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
`;





const FooterDiv = () => {
  return (
    <footer style={{ marginTop: rhythm(2) }}>
      <PathImage>
        <svg width="100%" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1920 313.416" preserveAspectRatio="xMinYMin meet">
          <path d="M4817,6429.7c439.876,286.634,621.2-56.373,886.469-43.053s441.275,173.169,642.045,173.169S6715.175,6446.1,6737,6451.15v248.536H4817Z" transform="translate(-4817 -6386.271)" />
        </svg>
      </PathImage>
      <div style={{ width: '100%', background: 'var(--color-foreground)' }}>
        <FooterContentDiv>
          <p style={{ margin: 0 }}>Thankyou for reading!</p>
          <Quote >
            Stay Inspired.
          </Quote>
          <p style={{ margin: 0 }}>
            Created with <span style={{ color: 'var(--color-secondary)' }}>❤</span>, Coded with
              <HoverUnderline>
              {" "}<a href="https://www.gatsbyjs.com/"
                aria-label="Gatsby"
                target="_blank"
                rel="noopener noreferrer"
                style={{ color: 'var(--color-secondary)' }}>Gatsby</a>
            </HoverUnderline>
          </p>
          <IconDiv>
            <SocialIcons/>
          </IconDiv>
          <small> © JAY GURAV {new Date().getFullYear()}</small>
        </FooterContentDiv>
      </div>
    </footer >
  )
}

export default FooterDiv;
